import Vue from 'vue';

export class EventBus {
  public static Register(event: EventBus.Event, callback: (...args: any[]) => void) {
    EventBus.bus.$on(event as unknown as string, callback);
  }

  public static Emit(event: EventBus.Event, ...args: any[]) {
    EventBus.bus.$emit(event as unknown as string, args);
  }

  private static bus = new Vue();
}

// tslint:disable-next-line:no-namespace
export namespace EventBus {
  export enum Event {
    SetupWizard = 'setup-wizard',
    EthernetConnectionUpdated = 'ethernet-connection-updated',
    OpenNotificationCenter = 'open-notification-center',
    VpnAdded = 'vpn-added',
  }
}
